module.exports = __webpack_public_path__ + "media/images/useek_logo_new-fa1387666cb65cc0e3410197ad0c482d.png";